import { fun_PostAction } from "@/api/index";
export default {
  data() {
    return {
      // 默认关闭
      dialogVisible: false,
      // 加载
      loading: false,
      // 查询表单绑定值
      form: {
        tenderPrjName: null, // 招标登记项目名称
        regulators: null, // 行政监督部门
      },
      // 查询表单基础数据
      formSearchList: [
        {
          type: "input",
          label: "招标登记项目名称：",
          value: "tenderPrjName",
          placeholder: "请输入",
          clearable: true
        },
        {
          type: "select",
          label: "招标投标监管部门：",
          value: "regulators",
          placeholder: "请输入",
          queryParams: {
            url: "/regulatorsCombobox",
            processType: "201512081755290013"
          }
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "招标登记编号",
          prop: "id",
          isShow: true,
          fixed: true,
          width: "200",
        },
        {
          label: "招标项目名称",
          prop: "tenderPrjName",
          fixed: true,
          width: "250",
        },
        {
          label: "项目编号",
          prop: "constructionNo",
          width: "200",
        },
        {
          label: "招标代理备案标号",
          prop: "agencyId",
          width: "200",
        },
        {
          label: "招标类别",
          prop: "tenderClassName",
          width: "200",
        },
        {
          label: "标段数",
          prop: "sectionQuantity",
          width: "80",
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "200",
        },
        {
          label: "行政监督部门",
          prop: "regulatorsName",
          width: "200",
        },
      ],
      // 列表数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      // 分页总条数
      total: 0,
      // 查询标志
      flag: null,
    };
  },

  // 接收父组件传递的数据
  props: {},

  // 模板编译完成
  mounted() {},
  // 自定义方法
  methods: {
    // 打开弹框时调用
    async fun_GetOpen() {
      // 查询一览数据
      this.fun_GetList();
    },
    /**
     * 获取列表一览数据
     * @author shuhua
     */
    fun_GetList() {
      // 打开loading
      this.loading = true;
      // 发起请求
      fun_PostAction("/tenderRegistrationChoose/list", {
        ...this.form,
        ...this.reqPageData,
        flag: this.flag // 页面查询标志
      }).then(res => {
        // 解构res.data
        const { result, data, msg } = res.data;
        // 操作成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 错误消息提示
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      });
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 项目选择选择
     */
    fun_TenderRegistrationSelect(e) {
      // 回调函数
      this.$nextTick(() => {
        // 赋值父页面
        this.$parent.fun_SetTenderRegistration(e.val.id);
        // 关闭页面弹框
        this.dialogVisible = false;
      });
    }
  }
};
